import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';

export default mutatorAction('SET_EXPORT_STATUS', (requestStatus: string) => {
    getStore().requestStatus = requestStatus;
});
